import { ArrowRight } from "lucide-react";
import { Reveal } from "../landing/shared";
import { IMAGES } from "@/config";

const FlatPosture = () => (
  <svg viewBox="0 0 220 170" className="h-32 w-full sm:h-36" fill="none" aria-label="Feet flat posture illustration">
    <line x1="14" y1="150" x2="206" y2="150" stroke="#1B2A4A" strokeOpacity="0.25" strokeWidth="3" strokeLinecap="round" />
    <path d="M132 100 H178 V112 C178 132 168 150 158 150 H146 C150 138 152 126 152 112 H132 Z" stroke="#1B2A4A" strokeWidth="4" strokeLinejoin="round" />
    <circle cx="112" cy="48" r="11" stroke="#1B2A4A" strokeWidth="4" />
    <path d="M116 60 L124 98" stroke="#1B2A4A" strokeWidth="4" strokeLinecap="round" />
    <path d="M124 98 L160 100 L160 146" stroke="#1B2A4A" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M160 146 H176" stroke="#1B2A4A" strokeWidth="4" strokeLinecap="round" />
    <path d="M124 76 L146 96" stroke="#1B2A4A" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

const ElevatedPosture = () => (
  <svg viewBox="0 0 220 170" className="h-32 w-full sm:h-36" fill="none" aria-label="Feet elevated posture illustration">
    <line x1="14" y1="150" x2="206" y2="150" stroke="#F5F0E6" strokeOpacity="0.3" strokeWidth="3" strokeLinecap="round" />
    <path d="M150 124 h30 v26 h-30 z" stroke="#B99B5C" strokeWidth="4" strokeLinejoin="round" />
    <path d="M132 100 H178 V112 C178 132 168 150 158 150 H150 C154 138 156 126 156 112 H132 Z" stroke="#F5F0E6" strokeWidth="4" strokeLinejoin="round" />
    <circle cx="106" cy="52" r="11" stroke="#F5F0E6" strokeWidth="4" />
    <path d="M110 64 L122 100" stroke="#F5F0E6" strokeWidth="4" strokeLinecap="round" />
    <path d="M122 100 L158 86 L166 120" stroke="#F5F0E6" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M158 120 H178" stroke="#F5F0E6" strokeWidth="4" strokeLinecap="round" />
    <path d="M118 80 L144 92" stroke="#F5F0E6" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

const Idea = () => (
  <section data-testid="simple-idea-section" className="bg-white py-14 sm:py-20">
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold">The simple idea</p>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-3 font-serif text-3xl leading-[1.12] tracking-tight text-navy sm:text-4xl lg:text-5xl" data-testid="idea-headline">
          Your Toilet Posture Matters.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-4 max-w-xl text-base leading-relaxed text-charcoal/80 sm:text-lg" data-testid="idea-copy">
          Elevating your feet can help create a more natural, squat-like toilet posture.
        </p>
      </Reveal>

      <div className="mt-10 grid items-stretch gap-4 sm:grid-cols-[1fr_auto_1fr] sm:gap-6">
        <Reveal delay={0.1}>
          <div className="flex h-full flex-col rounded-3xl border border-navy/10 bg-ivory p-6" data-testid="posture-card-flat">
            <FlatPosture />
            <div className="mt-auto pt-5">
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-charcoal/50">Feet flat</p>
              <p className="mt-1 font-serif text-xl font-semibold text-navy sm:text-2xl">Normal sitting posture</p>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.18} className="flex items-center justify-center">
          <div className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 bg-ivory text-gold sm:rotate-[-90deg]">
            <ArrowRight className="h-5 w-5 rotate-90 sm:rotate-0" />
          </div>
        </Reveal>
        <Reveal delay={0.26}>
          <div className="flex h-full flex-col rounded-3xl border border-gold/40 bg-navy p-6" data-testid="posture-card-elevated">
            <ElevatedPosture />
            <div className="mt-auto pt-5">
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold">Feet elevated</p>
              <p className="mt-1 font-serif text-xl font-semibold text-ivory sm:text-2xl">More squat-like posture</p>
            </div>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="mt-6">
        <div className="relative overflow-hidden rounded-3xl" data-testid="idea-product-in-use">
          <img
            src={IMAGES.inuse}
            alt="Medlinkx footstool in use in front of a toilet"
            className="h-52 w-full object-cover sm:h-64"
          />
        </div>
      </Reveal>
    </div>
  </section>
);

export default Idea;
